import React, { useEffect, useState } from 'react'
import { Useglobelcontext } from './blogcontext/Blogcontext';
import { NavLink, useNavigate, useParams  , useLocation } from 'react-router-dom';
import styled from "styled-components";
import { FaTag } from "react-icons/fa6";
import { BASE_URL } from '../Config/Config';
import SubLoading from '../ALL CSS/Loading';
import { UseGlobellogin } from './Logincontaxt.jsx/Logincontex';
import { RECAPTCHA_SITE_KEY } from './GlobelHelper/GlobelRechpcha';
import ReCAPTCHA from 'react-google-recaptcha';
import Event_Like_Viwe from './Like_Viwe';
import Auratech_Ads from './Auratech_Ads';
import Loader from '../Loader/Loader';

function Blogdetail() {
  const navigate = useNavigate();
  const location = useLocation(); 

  const { Getsinglblog  , singleblog , Allblogdata , Blogdata  , blogloading} = Useglobelcontext();
  const [refresh, setRefresh] = useState(false);
  const {userName , userEmail , userId , setsuccessfully , isLoggedIn } = UseGlobellogin();
  const [FormMessage,setFormMessage] = useState("");
  const [Error , setEror] = useState("");
  const [Enable , setEnable] = useState(true);
  
  const [loading , setloading] = useState(false);
  const [getblogcomment , setgetblogcomment] = useState([]);
  const { hash } = useLocation();
  const [blogcomment , setblogcomment] = useState({
    person_name : userName ? userName : "",
    person_email:  userEmail ?  userEmail : "",
    content: "" , 
  });

        const {slug} = useParams();
  const [bannerData , setBannerImage] = useState([]);
  const [bannerLoading , setBannerLoading] = useState(true);

  useEffect(() => {
    const fetchBannerImage = async () => {
      try {
        setBannerLoading(true);
        const response = await fetch(`${BASE_URL}/banner/?page=blogdetail`);
        const result = await response.json();
        setBannerImage(result.data[0]);
            } catch (error) {
              console.error('Error fetching banner:', error);
            } finally {
              setBannerLoading(false);
            }
          };
          
          fetchBannerImage();
        }, []);

       useEffect(()=>{
        if (slug){
               Getsinglblog(slug);
          }
        },[slug , Allblogdata]);

          function onChange(value) {
          setEnable(false);
        }

          useEffect(() => {
            // Set background image from data-bg-src
            const bgSrcElements = document.querySelectorAll('[data-bg-src]');
            bgSrcElements.forEach((element) => {
              const src = element.getAttribute('data-bg-src');
              if (src) {
                element.style.backgroundImage = `url(${src})`;
                element.classList.add('background-image');
                element.removeAttribute('data-bg-src');
              }
            });
        
            // Set background color from data-bg-color
            const bgColorElements = document.querySelectorAll('[data-bg-color]');
            bgColorElements.forEach((element) => {
              const color = element.getAttribute('data-bg-color');
              if (color) {
                element.style.backgroundColor = color;
                element.removeAttribute('data-bg-color');
              }
            });
        
            // Set mask image from data-mask-src
            const maskSrcElements = document.querySelectorAll('[data-mask-src]');
            maskSrcElements.forEach((element) => {
              const mask = element.getAttribute('data-mask-src');
              if (mask) {
                element.style.maskImage = `url(${mask})`;
                element.style.WebkitMaskImage = `url(${mask})`;
                element.classList.add('bg-mask');
                element.removeAttribute('data-mask-src');
              }
            });
          }, [slug]);  

     useEffect(() => {
        const getData = async () => {
          try {
            const response = await fetch(`${BASE_URL}/blogcomment/`,{
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
              credentials: 'include', 
            });
            const data = await response.json(); 
               setgetblogcomment(data.data);
            
          } catch (error) {
            console.error('Error fetching reviews:', error);
          }
        };
        getData(); 
      }, [refresh]);

    const updateInput =(event)=>{
     const {name , value} = event.target;
       setblogcomment({
        ...blogcomment,
        [name]:value,
       })
    }
    const sublitcomment = async () => {
    
   if(!isLoggedIn){
      navigate('/login', { state: { from: location } });
      console.log("aman");
   }
   else{
     console.log('aman mangal')
       setloading(true);
       const requestBody = {
          ...blogcomment,
      usermaster_id_id: userId,
      blog_id: singleblog[0]?.id ,
  };
      try {
        const response = await fetch(`${BASE_URL}/blogcomment/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body:JSON.stringify(requestBody),
        });
        if(response.ok){
          const commentdata = await response.json(); 
           setRefresh((prev) => !prev);
            setFormMessage(commentdata.message);
            setsuccessfully(commentdata.message)

             setblogcomment({
             person_name : userName ? userName : "",
             person_email:  userEmail ?  userEmail : "",
             content: "" , 
            })
            setTimeout(() => {
              setFormMessage(false);
            }, 5000);
            setTimeout(() => {
              setsuccessfully("");
            }, 5000);
          }
       } catch (error) {
          console.log(error);
       }
       finally{
               setloading(false);

       }

      }
    }

    
    useEffect(() => {
        if (hash) {
          const element = document.querySelector(hash);
          if (element) {
            element.scrollIntoView({ behavior: "smooth" });
          }
        }
      }, [hash]);
  return (
    <>
   {
      bannerLoading && bannerData && bannerData.image ? (
        <Loader/>
      ):(
   <div className="breadcumb-wrapper"

style={{
       backgroundImage: `url(${BASE_URL}${bannerData.image})`,
       backgroundSize: 'contain',
       backgroundPosition: 'center',
      //  height:"50px"
     }}    
    data-overlay="title" data-opacity={8}>
  <div className="breadcumb-shape" data-bg-src="/assets/img/bg/breadcumb_shape_1_1.png">
  </div>
  <div className="shape-mockup breadcumb-shape2 jump d-lg-block d-none" data-right="30px" data-bottom="30px">
    <img src="/assets/img/bg/breadcumb_shape_1_2.png" alt="shape" />
  </div>
  <div className="shape-mockup breadcumb-shape3 jump-reverse d-lg-block d-none" data-left="50px" data-bottom="80px">
    <img src="/assets/img/bg/breadcumb_shape_1_3.png" alt="shape" />
  </div>
  <div className="container">
    <div className="breadcumb-content text-center">
      <h1 className="breadcumb-title">Blog Details</h1>
      <ul className="breadcumb-menu">
        <li><a href="/">Home</a></li>
        <li>Blog Details</li>
      </ul>
    </div>
  </div>
</div>
      )}
    <Wrapper>
<section className="th-blog-wrapper blog-details space-top space-extra2-bottom" id="target-section">
  <div className="container">
  
  {
    blogloading ? (
      <SubLoading/>
    ):(
      <>
      { 
            singleblog.map((curdata , index)=>(
          <div className="row gx-30" key={index} id='blogtarget'>
            <div className="col-xxl-8 col-lg-7">
              <div className="th-blog blog-single">
                <div className="blog-img">
                  <img src={ curdata.blog_detail_img ? `${BASE_URL}${curdata.blog_detail_img}` : '/assets/img/AA_LOgo_Black.png'}alt="Blog Image" />
                </div>
              
                <div className="blog-content">
                  <div className="blog-meta">
                    
                    <NavLink className="author" to="/blog"><i className="far fa-user" />{curdata.author_name.author_name}</NavLink>
                    <NavLink to="/blog"><i className="fa-light fa-calendar-days" />{new Date(curdata.create_date).toLocaleDateString('en-CA')}</NavLink>
                    <NavLink to={`/blogdetail/${curdata.slug}`}><i className="fa-light fa-book" />{curdata.blogcategory}</NavLink>
                    <NavLink to={`/blogdetail/${curdata.slug}`}> <FaTag className='fa-light fa-tag'/> {curdata.tag}</NavLink>
                 
                  </div>
                   {/* <div className='d-flex gap-2'>
                  <Event_Like_Viwe/>
                  </div> */}

                  <h2 className="blog-title">{curdata.title}</h2>
      
      
                  {/* <p>{curdata.content}</p>
                  <p>A platform dedicated to exploring the transformative power of education. We believe that education is not only a means to acquire knowledge but also a catalyst for personal growth, societal progress, and global development. In this blog, we aim to inspire, inform, and engage readers in conversations about the latest trends, insights, and innovations in the field of 
                    education.</p> */}
                    <div
                       dangerouslySetInnerHTML={{ __html: curdata.content }}>
                       </div>
      
                  {/* <div className="blog-img mt-1">
                    <img className="w-100" src={`${BASE_URL}${curdata.image}`}alt="Blog Image" />
                  </div> */}
      
                </div>
                <div dangerouslySetInnerHTML={{__html:curdata.blog_detail}}></div>
      
                <div className="share-links clearfix  ">
                  <div className="row justify-content-between">
                    <div className="col-md-auto">
                      <span className="share-links-title">Tags:</span>
                      <div className="tagcloud">
                        {/* <NavLink to="/blog">Education</NavLink> */}
                        <NavLink to="/blog">{curdata.tag}</NavLink>
                      </div>
                    </div>
                    <div className="col-md-auto text-xl-end">
                      <span className="share-links-title">Share:</span>
                      <ul className="social-links">
                        <li><a href="https://facebook.com/" target="_blank" style={{marginRight:"10px"}}><i className="fab fa-facebook-f" /></a></li>
                        <li><a href="https://twitter.com/" target="_blank"><i className="fab fa-twitter" /></a></li>
                        <li><a href="https://linkedin.com/" target="_blank"><i className="fab fa-linkedin-in" /></a></li>
                        <li><a href="https://instagram.com/" target="_blank"><i className="fab fa-instagram" /></a></li>
                      </ul>
                    </div>{/* Share Links Area end */}
                  </div>
                </div>
              </div>
      
      
              <div className="th-comments-wrap ">
                <h2 className="blog-inner-title h5"> Comments {getblogcomment.length} </h2>
                <ul className="comment-list">
      
      
                  {getblogcomment?.map((curcomment , index)=>(
                  <li className="th-comment-item" key={index}>
                    <div className="th-post-comment">
                      <div className="comment-avater">
                        <img src="/profail.png" alt="Comment Author" />
                      </div>
                      <div className="comment-content">
                        <h3 className="name">{curcomment.person_name}</h3>

<span className="commented-on">
  {new Date(curcomment.create_date).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })}
</span>
                        
                        <p className="text">{curcomment.content}</p>
                        <div className="reply_and_edit">
                          {/* <NavLink to="blog-detail" className="reply-btn"><i className="fas fa-reply" />Reply</NavLink> */}
                        </div>
                      </div>
                    </div>
      
                    {/* <ul className="children">
                      <li className="th-comment-item">
                         <div className="th-post-comment">
                          <div className="comment-avater">
                            <img src="/assets/img/blog/comment-author-2.jpg" alt="Comment Author" />
                          </div>
      
                          <div className="comment-content">
                            <h3 className="name">Marvin McKinney</h3>
                            <span className="commented-on">25Aug, 2023 10:56pm</span>
                            <p className="text">Education News and Trends: We provide updates on the latest developments and trends in the education sector, including educational research,</p>
                            <div className="reply_and_edit">
                              <a href="blog-details.html" className="reply-btn"><i className="fas fa-reply" />Reply</a>
                            </div>
                          </div>
                        </div>  
                      </li>
                    </ul> */}
                  </li>
                   ))}
                </ul>
      
              </div> {/* Comment end */}
              
              
              
              {/* Comment Form */}
      
              <form className="th-comment-form" >
                <div className="form-title">
                  <h3 className="blog-inner-title h5">Leave a Reply</h3>
                  <p className="mb-30">Your email address will not be published. Required fields are marked</p>
                </div>
                <div className="row">
                  <div className="col-md-6 form-group">
                    <input type="text"
                     placeholder="Full Name*" 
                     name='person_name'
                     onChange={updateInput}
                     value={blogcomment.person_name}
                     className="form-control"
                      />
                    <i className="far fa-user" />
                  </div>
                  <div className="col-md-6 form-group">
                    <input type="email"
                    name='person_email'
                    onChange={updateInput}
                     placeholder="Your Email*"
                     value={blogcomment.person_email} 
                     className="form-control" 
                     required
                     />
                    <i className="far fa-envelope" />
                  </div>
                  
                  <div className="col-12 form-group">
                    <textarea 
                    placeholder="Comment*"
                    className="form-control"
                    name='content'
                    value={blogcomment.content}
                    onChange={updateInput}
                    required
                    defaultValue={""} 
                    />
                    <i className="fal fa-pencil" />
                  </div>
                   <ReCAPTCHA
                            sitekey={RECAPTCHA_SITE_KEY}
                            onChange={onChange}
                          />
                           {FormMessage && (
                            <div style={{fontSize:"1.3rem" , color:"green" ,marginBottom:"1rem"}}>
                            {FormMessage}
                           </div>
                               )}
    
                               {Error && (
                            <div style={{fontSize:"1.5rem" , color:"red" ,marginBottom:"1rem"}}>
                            {Error.message}
                           </div>
                              )}
      
                  <div className="col-12 form-group mb-0">
                    <button type="button" onClick={sublitcomment} className="th-btn" disabled={Enable}> {loading ? ( <>
                    <div className='d-flex gap-2'>    
                    post Comment....
                    </div>
                    </> 
                    ): ( <>Submit Message   <i className="fas fa-arrow-right ms-1" /></> )}</button>
                  </div>
                </div>
              </form>
            </div>
          {/* filter part of blog  */}
            <div className="col-xxl-4 col-lg-5">     
              <aside className="sidebar-area">
                {/* <div className="widget widget_search  ">
                  <form className="search-form">
                    <input type="text" placeholder="Search Product..." />
                    <button type="submit"><i className="far fa-search" /></button>
                  </form>
                </div> */}
                {/* <div className="widget widget_categories  ">
                  <h3 className="widget_title">Categories</h3>
      
                  <ul>
                    <li><a href="service-details.html">Design</a><span>(08)</span></li>
                    <li><a href="service-details.html">Development</a> <span>(12)</span></li>
                    <li><a href="service-details.html">Photography</a><span>(15)</span></li>
                    <li><a href="service-details.html">Health</a><span>(21)</span></li>
                    <li><a href="service-details.html">Health</a><span>(14)</span></li>
                    <li><a href="service-details.html">Finance</a><span>(05)</span></li>
                    <li><a href="service-details.html">Technology</a><span>(10)</span></li>
                  </ul>
                </div> */}
      
                <div className="widget  ">
                  <h3 className="widget_title">Recent Posts</h3>
                  <div className="recent-post-wrap">
                                 {Blogdata.map((curdata , index)=>(
                                 <div className="recent-post" key={index}>
                                   <div className="media-img">
                                     <NavLink to={`/blogdetail/${curdata.slug}`}><img src={`${BASE_URL}${curdata.image}`} alt="Blog Image" /></NavLink>
                                   </div>
                                   <div className="media-body">
                                     <h4 className="post-title"><NavLink className="text-inherit" to={`/blogdetail/${curdata.slug}`}>{curdata.title}</NavLink></h4>
                                     <div className="recent-post-meta">

 <NavLink to="/blog"><i className="fa-light fa-calendar-days" />{new Date(curdata.create_date).toLocaleDateString('en-CA')}</NavLink>
                                     </div>
                                   </div>
                                 </div>
                                  ))}
                          </div>
                         </div>

               <Auratech_Ads/>
                

              </aside>
            </div>
          </div>
      ))}
      </>
    )
  }


  </div>
</section>
</Wrapper>

    </>
  )
}

const Wrapper =  styled.section`
  .blog-img img {
  width: 55rem;
  height: 26rem;
  }

`;


export default Blogdetail